import "./BreadcrumbMeeting.scss";

import { ellipsis } from "ApiConstraints";
import { DisplayLocked } from "components/DisplayFields/DisplayLocked";
import { createLogger } from "logging";
import { useMeeting, useTranslations } from "providers";
import React from "react";

const logger = createLogger("HeaderMeeting");

export const BreadcrumbMeeting: React.FC = () => {
  const i18n = useTranslations();
  const { isLoading, meeting } = useMeeting();

  if (isLoading) {
    return null;
  }

  if (!meeting) {
    return null;
  }

  const { id: meetingId, title = "", locked, overlength, isTemplate } = meeting;
  logger.trace(`render(): `, JSON.stringify({ meetingId, isLoading, overlength, isTemplate }));

  let displayTitle = title || ellipsis;
  if (displayTitle.length > 50) {
    displayTitle = `${displayTitle.substring(0, 49)}${ellipsis}`;
  }

  const titleTemplate = isTemplate ? i18n.Page_StandardMeetingName_Title : i18n.Page_MeetingName_Title;
  const longTitle = titleTemplate.replace("{0}", title);
  const shortTitle = titleTemplate.replace("{0}", displayTitle);

  return (
    <div className="breadcrumb-meeting global-tooltip-trigger" title={longTitle}>
      <span className="title">{shortTitle}</span>
      <span className={overlength ? "meeting-status-red" : "meeting-status-green"}>
        <i className="ms-Icon ms-Icon--CircleFill" />
      </span>
      <DisplayLocked value={locked} entityName="Meeting" name="Locked" />
    </div>
  );
};
